export default [
  {
    path: '/discoverList',
    name: 'discoverList',
    component: () => import ('@/components/page/discover/discoverList')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/discover.js